import React ,{useState,useEffect}from 'react'
import { Link, useNavigate,useLocation } from 'react-router-dom'
import ClientDashboardChart from '../../ClientDashboardChart'
import VerticalGraph from './VerticalGraph'
import { useDispatch } from 'react-redux'
import { UPDATE_FILTER_DATA } from '../../../redux/features/user/filterSlice'
import LeadsPieChart from './LeadsPieChart'
import './social_media_metrics_card.css'
import { isString } from 'react-advanced-cropper'
import { getPlatformName, getPlatformNameOrId } from '../../../helpers/getPlatformName'

const SocialMediaMetricsCard = ({ socialMediaData, keys }) => {

    const navigate = useNavigate()
    const [activeTab,setActiveTab]=useState(keys[0].toLowerCase())
    const [chartData,setChartData]=useState({
        values:[],
        labels:[]
    })
    const dispatch = useDispatch()
    const location=useLocation()
    
  

    const handleNavigation = (selectedPlatform) => {
        try {

            if (selectedPlatform?.value && selectedPlatform?.label != "") {
                dispatch(UPDATE_FILTER_DATA({ filter_ads_platform: selectedPlatform }))
                navigate('/client/campaigns')
            }
            let url=location?.pathname?.split('/')
            let endpoint=url[url?.length-1] ?? ''
            // console.log(selectedPlatform,"Selected Platform")
            if(endpoint==="owned_media")
            {
                navigate('/client/organic-social')

            }
            if(endpoint==="organic_social")
            {
                 navigate('/client/organic-social')
                 dispatch(UPDATE_FILTER_DATA({ select_organic_social_platform: selectedPlatform }))
            }
            if(endpoint==="paid_media")
            {
                // console.log(selectedPlatform)
            }
         


        } catch (e) {
            console.log(e)
        }

    }
    const handleTabChange=(selectedTab)=>{
       
        setActiveTab(selectedTab)
        const filteredMatrics =socialMediaData?.matrics?.filter(item => item.name !== 'OverView');

        const chartLabels = filteredMatrics.map(item => item.name);

        const chartData = filteredMatrics.map(item => {
            if (selectedTab === 'spend') {
                // Remove '$' and convert to number
                return item?.spend && parseFloat(item?.spend.replace('$', ''));
            }
            return item[selectedTab]; // 'clicks' or 'impressions'
        });
        
        setChartData((prev)=>{
            return {...prev,values:chartData,labels:chartLabels}
        })
    }

    useEffect(()=>{
        if (socialMediaData?.matrics?.length) {
            handleTabChange(keys[0].toLowerCase());
          }

    },[])




    return (
        <div className="row social_media_card_wrapper m-0">
            <div className="col-md-8">
                <div className='row '>

                    {socialMediaData?.matrics?.map((social_media, index) => {
                          
                        return <div className={`col-md-6 social_media_metric_card px-4 py-2 ${(index == 2 || index == 3) ? 'card_border_right' : 'card_border'} `}>
                            <div>
                                {/* heading */}
                                <div className='py-4  d-flex align-items-center gap-2 heading'>
                                    {social_media?.icon && <img src={social_media?.icon} alt="" />}
                                    <h5 className='mb-0'>{social_media?.name}</h5><span className='cursor-pointer' onClick={() => handleNavigation(social_media?.selectedPlatform)}> View Details</span>
                                </div>
                                {/* metrics */}
                                <div className="row ">
                                   <div className="col-12  my-sm-2 " >
                                        <div className='metrics_card_spend'>
                                        <span>{keys[0] ? keys[0] : ''}</span>
                                       <p className="mb-0"> {Number(String(social_media?.spend ?? 0).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                                        </div>
                                   </div>

                                   {social_media?.platform_id==getPlatformNameOrId('Instagram') ?(<>
                                         <div className="col-md-6 col-12 mb-2 ">
                                        <div className='metrics_card_other'>
                                        <span>Reach</span>
                                 
                                        <p className="mb-0"> {Number(String(social_media?.reach ?? 0).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>

                                        </div>
                                      
                                    </div>
                                    <div className="col-md-6 col-12 mb-2 ">
                                    <div className='metrics_card_other metrics_card_clicks'>
                                            <span>Likes</span>
                                          
                                            <p className="mb-0"> {Number(String(social_media?.likes ?? 0).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                                            
                                    </div>
                                        
                                    </div>
                                   
                                   </>):(<>
                                    <div className="col-md-6 col-12 mb-2 ">
                                        <div className='metrics_card_other'>
                                        <span>{keys[1] ? keys[1] : ''}</span>
                                    
                                        <p className="mb-0"> {Number(String(social_media?.impressions ?? 0).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>

                                        </div>
                                      
                                    </div>
                                    <div className="col-md-6 col-12 mb-2 ">
                                    <div className='metrics_card_other metrics_card_clicks'>
                                            <span>{keys[2] ? keys[2] : ''}</span>
                                           
                                            <p className="mb-0"> {Number(String(social_media?.clicks ?? 0).replace(/[^\d.-]/g, "") || 0).toLocaleString("en-US")}</p>
                                            

                                            
                                            
                                    </div>
                                        
                                    </div>
                                   
                                   </>)}

                                   


                                </div>
                                {/* graph */}
                                {/* <div className='py-2'>
                                    <ClientDashboardChart border_color={social_media?.border_color} graph_data={social_media?.graph_data} />
                                </div> */}
                            </div>
                        </div>

                    })}




                </div>

            </div>
            <div className="col-md-4 social_media_metric_vertical_card p-3">
                <div className='d-flex flex-column  h-100'>
                    <h5 className='mb-0 pb-3 pt-1'>Total</h5>
                    {/* <div className="row pb-md-5 pt-md-3">
                        <div className="col-md-4 col-sm-6 my-sm-3">
                            <p className='mb-0 spent'>{socialMediaData?.total?.spend}</p>
                            <span>{keys[0] ? keys[0] : ''}</span>
                        </div>
                        <div className="col-md-4 col-sm-6 my-sm-3">
                            <p className='mb-0 spent'>{socialMediaData?.total?.impressions}</p>
                            <span>{keys[1] ? keys[1] : ''}</span>
                        </div>
                        <div className="col-md-4 col-sm-6 my-sm-3">
                            <p className='mb-0 spent'>{socialMediaData?.total?.clicks}</p>
                            <span>{keys[2] ? keys[2] : ''}</span>
                        </div>

                    </div> */}
                    <div className='d-flex justify-content-between gap-1'>
                        {keys?.length>0 && keys?.map((key)=>{

                            return     <button className={`flex-grow-1 post_metrics_tab ${activeTab===key.toLowerCase()?'btn-primary active_metrics_tab':'btn-secondary'}  `}
                            onClick={()=>handleTabChange(key.toLowerCase())}
                           >{key}</button>

                        })}
                    
                        {/* <button 
                         onClick={()=>handleTabChange('impressions')}
                        className={`flex-grow-1 ${activeTab==="impressions"?'btn-primary':'btn-secondary'}  `}>Impressions</button>
                        <button className={`flex-grow-1 ${activeTab==="clicks"?'btn-primary':'btn-secondary'} `}
                           onClick={()=>handleTabChange('clicks')}
                        >Clicks</button> */}
                    </div>
                    <div className='py-3 d-flex justify-content-center align-items-center flex-grow-1 ' >
                        {/* <VerticalGraph graph_data={socialMediaData?.total?.graph_data} /> */}
                        <div style={{width:'65%',aspectRatio:'1/1'}}>
                        <LeadsPieChart values={chartData?.values} labels={chartData?.labels} legend={true}/>
                        </div>
                      
                    </div>


                </div>


            </div>
        </div>
    )
}

export default SocialMediaMetricsCard